import Home from '@pages/home';
import Login from '@pages/login';
import HotelListing from '@pages/hotel-listing';
import HotelsInLucknow from '@pages/hotels-in-lucknow';
import HotelDetails from '@pages/hotel-details';
import Bookhotel from '@pages/book-hotel';
import BookingConfirm from '@pages/booking-confirm';
import UserProfile from '@pages/user-profile';
import TAProfile from '@pages/ta-profile';
import CreateTABooking from '@pages/ta-profile/CreateTABooking';
import PropertyInquery from '@pages/property-inquery';
import PageNotFound from '@pages/not-found';


import About from '@pages/other-pages/About';
import Career from '@pages/other-pages/Career';
import UserAgreement from '@pages/other-pages/UserAgreement';
import HowItWorks from '@pages/other-pages/HowItWorks';
import HelpCenter from '@pages/other-pages/HelpCenter';
import PrivacyPolicy from '@pages/other-pages/PrivacyPolicy';
import TermsAndConditions from '@pages/other-pages/TermsAndConditions';
import CancellationRefundPolicy from '@pages/other-pages/CancellationRefundPolicy';
import PartnershipPrograms from '@pages/other-pages/PartnershipPrograms';
import PromotionEvents from '@pages/other-pages/PromotionEvents';
import Community from '@pages/other-pages/Community';
import Contact from '@pages/other-pages/Contact';



export default{
    Home,
    Login,
    HotelListing,
    HotelsInLucknow,
    HotelDetails,
    Bookhotel,
    BookingConfirm,
    UserProfile,
    TAProfile,
    CreateTABooking,
    PropertyInquery,
    PageNotFound,

    About,
    Career,
    UserAgreement,
    HowItWorks,
    HelpCenter,
    PrivacyPolicy,
    TermsAndConditions,
    CancellationRefundPolicy,
    PartnershipPrograms,
    PromotionEvents,
    Community,
    Contact
}